'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'

export default function SafetyPage() {
  const { theme } = useTheme()
  const isDark = theme === 'dark'

  const bg = isDark ? '#0f172a' : '#f4f7fb'
  const ink = isDark ? '#e8f0fb' : '#0a1f3a'
  const secondary = isDark ? '#94a3b8' : '#6b7684'
  const border = isDark ? '#2c3a52' : '#e9eff7'

  const guides = [
    { title: '프리다이빙 안전 수칙', href: '/safety/rules', desc: '반드시 지켜야 할 안전 규칙' },
    { title: '이퀄라이징 기법', href: '/safety/equalization', desc: '귀 압력 조절 방법' },
    { title: '블랙아웃 대처법', href: '/safety/blackout', desc: '의식 상실 시 응급 대응' },
    { title: '응급처치 가이드', href: '/safety/first-aid', desc: '수중 사고 대응 방법' },
    { title: '버디 시스템', href: '/safety/buddy-system', desc: '버디의 중요성과 역할' },
  ]

  return (
    <div style={{ background: bg, minHeight: '100vh', padding: '32px 20px 80px' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <h1 style={{ font: '700 22px/30px sans-serif', color: ink, margin: '0 0 4px' }}>
          안전 가이드
        </h1>
        <p style={{ font: '400 13px/20px sans-serif', color: secondary, margin: '0 0 24px' }}>
          프리다이빙을 안전하게 즐기기 위한 필수 안전 수칙입니다.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {guides.map(g => (
            <Link
              key={g.href}
              href={g.href}
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '16px 0',
                borderBottom: `1px solid ${border}`,
                textDecoration: 'none',
              }}
            >
              <span style={{ font: '600 15px/22px sans-serif', color: ink, marginBottom: 2 }}>
                {g.title}
              </span>
              <span style={{ font: '400 13px/20px sans-serif', color: secondary }}>{g.desc}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
